class PasswordModal extends ModalDialog {
  constructor() {
    super();

    this.addEventListener("click", (event) => {
      if (event.target.classList.contains("modal-dialog-wrap")) {
        this.hide();
      }
    });
  }

  connectedCallback() {
    super.connectedCallback();

    if (this.querySelector('input[aria-invalid="true"]')) {
      this.show();
    }
  }
}

customElements.define("password-modal", PasswordModal);
